export default __webpack_public_path__ + "img/9f2944e141537e788767b82fc77a87ee.svg";